// extracted by mini-css-extract-plugin
export var bounce = "_nc-1";
export var generatingText = "_nc-6";
export var lightning = "_nc-4";
export var popup = "_nc-5";
export var progressBar = "_nc-7";
export var progressFill = "_nc-8";
export var progressShimmer = "_nc-9";
export var progressText = "_nc-a";
export var shimmer = "_nc-3";
export var uploadIcon = "_nc-0";
export var uploadingText = "_nc-2";